import React from 'react'
import {tenantTutorialLink} from './tenantState'

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  /** Section key (e.g. 'products', 'orders') used to look up a tenant's own tutorial video. */
  section: string
  /** Dumyah's baked-in walkthrough URL — shown only for Dumyah (or a tenant that overrides it). */
  fallback: string
}

/**
 * A "Video Link" tutorial button that renders ONLY when the active tenant should see it
 * (see {@link tenantTutorialLink}): Dumyah gets its baked-in walkthrough, a white-label tenant gets
 * its own per-section video or nothing at all — never Dumyah's video. All other anchor props
 * (className, onClick, target, rel, children …) pass straight through, so each call site keeps its
 * exact styling and behaviour; only the `href` and the show/hide decision are centralised here.
 */
export const TutorialVideoLink: React.FC<Props> = ({section, fallback, children, ...rest}) => {
  const href = tenantTutorialLink(section, fallback)
  if (!href) return null
  return (
    <a {...rest} href={href}>
      {children}
    </a>
  )
}

export default TutorialVideoLink
